export default function buildTaxonomicTreeMultiple(taxonomicData, domain = 'bacteria') {
    const nodeMap = {};
    const availableDomains = new Set();
    const forced_parent_child_relationship_order = ['sk', 'p', 'c', 'o', 'f', 'g', 's'];

    const unifiedRoot = {
        name: "root",
        rank: "root",
        count: 0,
        children: []
    };

    const isValidRank = (rank) => forced_parent_child_relationship_order.includes(rank);

    const isValidRelationship = (parentRank, childRank) => {
        if (parentRank === "root" && childRank === "sk") return true;

        const parentIndex = forced_parent_child_relationship_order.indexOf(parentRank);
        const childIndex = forced_parent_child_relationship_order.indexOf(childRank);

        return parentIndex !== -1 && childIndex !== -1 && parentIndex < childIndex;
    };

    taxonomicData.forEach(({ ncbi_id, name, rank, total_count }) => {
        if (!isValidRank(rank)) return;

        if (rank === 'sk') {
            availableDomains.add(name.toLowerCase());
        }

        if (!nodeMap[ncbi_id]) {
            nodeMap[ncbi_id] = {
                name: name,
                rank: rank,
                count: total_count,
                children: []
            };
        }
        nodeMap[ncbi_id].count = total_count;
    });

    taxonomicData.forEach(({ ncbi_id, parent_ncbi_id, rank }) => {
        if (!isValidRank(rank) || !nodeMap[ncbi_id]) return;

        if (parent_ncbi_id !== null) {
            if (!nodeMap[parent_ncbi_id]) return;

            const parentRank = nodeMap[parent_ncbi_id].rank || "unknown";

            if (!isValidRelationship(parentRank, rank)) return;

            nodeMap[parent_ncbi_id].children.push(nodeMap[ncbi_id]);
        } else {
            if (rank === 'sk') {
                unifiedRoot.children.push(nodeMap[ncbi_id]);
            }
        }
    });

    const targetDomain = domain.toLowerCase();
    const domainNode = unifiedRoot.children.find(child =>
        child.rank === 'sk' && child.name.toLowerCase() === targetDomain
    );

    return {
        tree: domainNode || unifiedRoot,
        availableDomains: Array.from(availableDomains)
    };
}